import BaseService from "./BaseService";
import { OrganizationService } from "@/api/services";
import { ChannelService } from "@/api/services";

/**
 * Service class for interacting with the 'scope' resource in the API.
 * Extends the BaseService class.
 */
class StatisticsService extends BaseService {
  /**
   * The resource endpoint for the 'scope' service.
   * @type {string}
   */
  resource = "stats";

  async getStatistics(model, model_id) {
    const { statisticsData: data } = await this.api.get(`/${this.resource}/${model}/${model_id}`);

    return { data };
  }

}

const statisticsServiceInstance = new StatisticsService();

export default statisticsServiceInstance;
